export const GlobalVariableValues = {
    GradingOutputAbove50:30,
    GradingOutputBelow50:33,
    companyId:31,
    assetmanagementcompanyId:9,
    salemoduleId:4,
    warehouseModuleId:1,
    hrmsModuleId:2,
    procurementmoduleId:5,
    logisticsmoduleId:6,
    downtimeModuleId:12,
    supplierPortaModuleId:13,
    rmProcurementmoduleId:14,
    assetManagementmoduleId:11,
    canteenmanagementmoduleId:16,
    AllModuleId:15,
    vistorManagementId:18,
    productionModuleId : 20,
    enquiryModuleId:34,
    cookingId: 1,    //to get the boiler fuel cost for the cooked products in cost sheet
    destinationId:31, //for MTS orders taking fixed destination (plant destination)
    boxWeight: 1.8,  // to calculate total reweighment qty
    NAbrandId : 43, // to get N/A brand info in enquiry product form
    productionVersion : 'V2' ,  // V1 for sandya aqua , V2 for BMR functionality
    countryIdForFrozenWeigth : 8,  // For china frozen weight should not be required
    incentiveFixedVariable : 6.5 ,  //Fixed variable to calculate incentive percentage in cost sheet
    incentivePerLabel : 6.6,   //Fixed variable to show the label of incentive percentage in cost sheet
    headOfficeUnitId : 5,
    generalStoreLocation: 9,
    companyName: "BMR Manufacturing",
    driverId:17,
    cartonId:1,
    pouchId:26,
    serviceCharge:10,
    meastriServiceCharge:5,
    numbersUomId : 11,          // using for item creation UOM saving while generating BOM from SO
    HONProductId : 14,            //value addition one id for head on shell on to compare products in prodution analysis report
    USACountryId  : 1,  
    CANADACountryId : 3,
    masterNABrandId : 1,
    RMItemcategoryId : 32,
    NACertificationId : 55,  // as certification info considered against product, so against certification details need to be considered as N/A
    FOBShippmenttermId : 1   // to consider ocean frieght rate as 0 if shippment term is FOB while generating cost sheet.

}